export interface WindowLandmark{
    time: number,
    frame: number,
    offset: number,
    coordinate: number,
    isHidden?: boolean
}

export type trimPoint = [number, number];
export type windowLandmark = [number, number];

export interface tempPlatformLandmarks{
    steam_time: number
    coordinate: number
}

export enum EditWindowMode {
    'auto' = 'auto',
    'manual' = 'manual',
}

export enum EditMode {
    'preview' = 'preview',
    'editor' = 'editor',
}

export interface EditModeOption{
    id: EditMode;
    label: string;
    disabled?: boolean;
}

export interface EditWindowModeOption{
    id: EditWindowMode;
    label: string;
    disabled?: boolean;
}

export interface AdjustWindowRequestElement{
    event_id: string
    mode: EditWindowMode
    trim_points: trimPoint[]
    landmarks: windowLandmark[]
    hidden_landmarks?: windowLandmark[]
    trim_labels: string[]
    stream_reference?: number
    real_stream_reference?: number
    discriminator?: string
}

export interface AdjustWindowResponseElement extends AdjustWindowRequestElement{
    coordinates: number[][]
}

export const ModeStatus = {
    CREATE: "CREATE",
    EDIT: "EDIT",
} as const;

export type ModeStatus = typeof ModeStatus[keyof typeof ModeStatus];

export const EDITOR_CONTENT_TYPE = {
    KEY_MOMENT: 'keyMoment',
    CLIP: 'clip'
}

export type ContentType = typeof EDITOR_CONTENT_TYPE[keyof typeof EDITOR_CONTENT_TYPE];

export interface HLSSegment {
    uri: string;
    duration: number;
    map?: {
        uri: string;
        byterange?: { length: number; offset: number }; // TODO: probably not needed, I don't think we will use byteranges in our HLS files
    };
}